export const tabItems = [
  {
    label: "Details",
    tabindex: 0,
  },
  {
    label: "Test Builds",
    tabindex: 1,
  },
];
